import styled from 'styled-components';

const LayoutStyles = styled.div`

/* =======================
   HEADER
======================= */
.ant-layout-header {
  background: transparent !important;
  padding: 0;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
}

/* =======================
   SIDER (CONTENEDOR)
======================= */
.ant-layout-sider {
  background: transparent !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  will-change: width, flex;
}

.ant-layout-sider > .ant-layout-sider-children {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sider-pin-toggle {
  display: flex;
  justify-content: flex-end;
  padding: 8px;
}

.sider-pin-toggle .ant-btn {
  border-radius: 6px;
}

.sider-pin-toggle .ant-btn,
.sider-pin-toggle .ant-btn:hover,
.sider-pin-toggle .ant-btn:focus,
.sider-pin-toggle .ant-btn:active {
  background: transparent !important;
}

.sider-pin-toggle .ant-btn .anticon {
  color: rgba(0, 0, 0, 0.55);
  font-size: 16px;
}

.sider-pin-toggle .ant-btn.is-pinned .anticon {
  color: #1677ff;
}

.ant-layout-sider.ant-layout-sider-collapsed .sider-pin-toggle {
  display: none;
}

/* =======================
   LOGO
======================= */
.logo {
  max-width: 250px;
  text-align: center;
  padding-left: 20px;
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s;
  will-change: opacity, transform;
}

.ant-layout-sider.ant-layout-sider-collapsed .logo {
  opacity: 0;
  transform: translateX(-10px);
  visibility: hidden;
  position: absolute;
}

/* =======================
   MENU BASE & ITEMS
======================= */
.ant-layout-sider .ant-menu::-webkit-scrollbar {
  display: none;
}
.ant-layout-sider .ant-menu {
  flex: 1;
  border-right: 0;
  background: transparent !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-menu-item, 
.ant-menu-submenu-title,
.menu-item-expanded-text,
.anticon {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* =======================
   ESTADO COLAPSADO
======================= */
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-item,
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-submenu-title {
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 48px;
}

.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-submenu-arrow,
.ant-layout-sider.ant-layout-sider-collapsed .menu-item-expanded-text,
.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-title-content {
  opacity: 0 !important;
  width: 0 !important;
  max-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden;
  display: none; /* Evita saltos de layout */
}

.ant-layout-sider.ant-layout-sider-collapsed .ant-menu-item-icon,
.ant-layout-sider.ant-layout-sider-collapsed .anticon {
  margin: 0 !important;
  font-size: 19px !important; /* Ligeramente más grande para resaltar */
  transform: scale(1.1);
}

/* =======================
   ESTADO EXPANDIDO
======================= */

.ant-layout-sider:not(.ant-layout-sider-collapsed) .menu-item-expanded-text {
  opacity: 1 !important;
  width: 100% !important;
  display: inline-block !important;
  transition: opacity 0.4s ease 0.1s, width 0.3s ease !important;
}

.ant-layout-sider:not(.ant-layout-sider-collapsed) .anticon {
  transform: scale(1);
  margin-right: 10px; /* Espacio natural con el texto */
}

/* =======================
   INTERACCIONES & FOOTER
======================= */
.ant-menu-item:active, .ant-menu-submenu-title:active {
  background: rgba(0, 0, 0, 0.05);
}

.ant-layout-footer {
  padding: 10px 50px;
  transition: all 0.3s ease;
}

.ant-menu-sub.ant-menu-inline {
  background: rgba(0, 0, 0, 0.01) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.ant-menu-item-only-child {
  padding-left: 48px !important;
  transition: background 0.3s ease !important;
}

.ant-menu-item-only-child:hover {
  background-color: #f0f0ff !important;
}

.ant-menu-item-only-child .anticon {
  font-size: 14px !important; /* Hijos un poco más pequeños */
}

`;

export default LayoutStyles;